/**
 * Created by Florin David on 30/06/2020.
 */

import Action, { ADD_CHAT_ENTRY, SET_QUESTION } from 'constants/action-types'

/**
 * Generic errors
 */
export default (state = '', action: Action): string => {
  switch (action.type) {
    case SET_QUESTION:
      return action.payload
    case ADD_CHAT_ENTRY:
      return ''
    default:
      return state
  }
}
